import { Component, HostListener, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from "./components/common/header/header.component";
import { FooterComponent } from "./components/common/footer/footer.component";
import { DeviceService } from './services/device.service';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { GoogleAnalyticsService } from './services/tracking/google-analytics.service';
import { MicrosoftClarityService } from './services/tracking/microsoft-clarity.service';
import { EnvironmentService } from './services/environment.service';
import { AppInsightsService } from './services/tracking/appInsights.service';
import { PosthogService } from './services/tracking/posthog.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, TranslocoPipe],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  deviceService = inject(DeviceService);
  translateService = inject(TranslocoService);
  googleAnalyticsService = inject(GoogleAnalyticsService);
  microsoftClarityService = inject(MicrosoftClarityService);
  environmentService = inject(EnvironmentService);
  appInsightsService = inject(AppInsightsService);
  posthogService = inject(PosthogService);

  @HostListener('window:load', ['$event']) onLoad(event: any) {
    this.deviceService.screenWidth = window.innerWidth;
  }
  
  @HostListener('window:resize', ['$event']) onResize(event: any) {
    this.deviceService.screenWidth = window.innerWidth;
  }

  constructor() {
    if (this.environmentService.isProduction() || this.environmentService.isUAT()) {
      this.googleAnalyticsService.init();
      this.microsoftClarityService.init();
    }

    this.posthogService.init();
  }

  public skipToMainContent() {
    document.getElementById("main")?.focus({preventScroll: true});
  }
  
}
